import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Spinner } from "../ui/spinner";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps): JSX.Element {
  const { user, isAuthenticated, mustChangePassword, booting } = useAuth();
  const location = useLocation();

  // I1 (C56 review): enquanto o boot de auth resolve o refresh de sessao (F5 com user
  // hidratado mas sem access em memoria), segura o render dos children pra nao disparar
  // queries sem Bearer (corrida acidental que so era recuperada pelo interceptor 401).
  if (booting) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="h-8 w-8" />
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  // Usuário com senha inicial (must_change_pwd) é travado em /trocar-senha até
  // trocar. Ele não navega pra mais nada do app antes disso (RN de segurança).
  if (mustChangePassword && location.pathname !== "/trocar-senha") {
    return <Navigate to="/trocar-senha" replace />;
  }

  return <>{children}</>;
}
